"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _wizard = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/wizard.css") : void 0);

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _wizard.default);
var WIZARD_CONNECTOR_TYPES = process.env.NODE_ENV !== "production" ? ['none', 'default', 'active', 'branching'] : {};
var WIZARD_STEP_MODIFIERS = process.env.NODE_ENV !== "production" ? ['completed', 'current', 'upcoming', 'no-label', 'stacked', 'stacked-top', 'active'] : {};

function WizardStep(_ref) {
  var _classnames, _context2, _classnames2;

  var branching = _ref.branching,
      connector = _ref.connector,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      glyph = _ref.glyph,
      indicator = _ref.indicator,
      modifiers = _ref.modifiers,
      nextLabel = _ref.nextLabel,
      optionalLabel = _ref.optionalLabel,
      menu = _ref.menu,
      onClick = _ref.onClick,
      title = _ref.title,
      valid = _ref.valid,
      props = (0, _objectWithoutProperties2.default)(_ref, ["branching", "connector", "className", "cssNamespace", "glyph", "indicator", "modifiers", "nextLabel", "optionalLabel", "menu", "onClick", "title", "valid"]);
  var stepClasses = classnames("".concat(cssNamespace, "-wizard__step"), (0, _map.default)(modifiers).call(modifiers, function (modifier) {
    var _context;

    return (0, _concat.default)(_context = "".concat(cssNamespace, "-wizard__step--")).call(_context, modifier);
  }), className);
  var labelContainerClasses = classnames((_classnames = {}, (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-wizard__label-container"), true), (0, _defineProperty2.default)(_classnames, "".concat(cssNamespace, "-wizard__label-container--optional"), optionalLabel), _classnames));
  var connectorClasses = classnames((_classnames2 = {}, (0, _defineProperty2.default)(_classnames2, "".concat(cssNamespace, "-wizard__connector"), true), (0, _defineProperty2.default)(_classnames2, (0, _concat.default)(_context2 = "".concat(cssNamespace, "-wizard__connector--")).call(_context2, connector), connector !== 'default'), _classnames2));

  var link = function link(linkClick) {
    return /*#__PURE__*/_react.default.createElement("a", {
      "aria-label": title,
      className: classnames("".concat(cssNamespace, "-wizard__step-container")),
      onClick: linkClick // hack to counter a fundamental-styles rule preventing proper navigation
      ,
      style: {
        pointerEvents: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(cssNamespace, "-wizard__step-indicator"))
    }, glyph ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      ariaLabel: glyph,
      className: classnames("".concat(cssNamespace, "-wizard__icon")),
      glyph: glyph
    }) : indicator), /*#__PURE__*/_react.default.createElement("div", {
      className: labelContainerClasses
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(cssNamespace, "-wizard__label"))
    }, title), optionalLabel && /*#__PURE__*/_react.default.createElement("span", {
      className: classnames("".concat(cssNamespace, "-wizard__optional-text"))
    }, optionalLabel)));
  };

  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
    className: stepClasses
  }, props), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(cssNamespace, "-wizard__step-wrapper"))
  }, menu && /*#__PURE__*/_react.default.createElement(_Popover.default, {
    body: menu,
    control: link()
  }), !menu && link(onClick), connector !== 'none' && /*#__PURE__*/_react.default.createElement("span", {
    className: connectorClasses
  })));
}

process.env.NODE_ENV !== "production" ? WizardStep.propTypes = {
  title: _propTypes.default.string.isRequired,

  /** (integrated only) Mark step as having unknown following content. */
  branching: _propTypes.default.bool,

  /** (integated only) Nodes to render as step content. */
  children: _propTypes.default.node,

  /** CSS class(es) to add to the element. */
  className: _propTypes.default.string,

  /** (standalone only) Appearance of the connector to the next element. */
  connector: _propTypes.default.oneOf(WIZARD_CONNECTOR_TYPES),

  /** Icon glyph to display in the indicator component. */
  glyph: _propTypes.default.node,

  /** Text to display in the indicator component if no glyph given. */
  indicator: _propTypes.default.string,

  /** Menu to show instead of triggering a click even. Used mostly for
   * stacking steps. */
  menu: _propTypes.default.node,

  /** (standalone only) Step appearance modifiers. */
  modifiers: _propTypes.default.arrayOf(_propTypes.default.oneOf(WIZARD_STEP_MODIFIERS)),

  /** (integrated only) Label to use on the next step button. */
  nextLabel: _propTypes.default.string,

  /** Label to use as the optional text in step header. */
  optionalLabel: _propTypes.default.string,

  /** (integrated only) Label to use on the previous step button. */
  previousLabel: _propTypes.default.string,

  /** (integrated only) True if moving to the next step is allowed. */
  valid: _propTypes.default.bool,
  onClick: _propTypes.default.function
} : void 0;
WizardStep.defaultProps = {
  modifiers: [],
  valid: true
};

var _default = (0, _withStyles.default)(WizardStep);

exports.default = _default;